import { useCallback, useRef, useState } from 'react';
import type { MobileNav, MobileScreen, ScanScenario } from '../types/mobile';

export function useMobileNav(initial: MobileScreen = 'splash'): MobileNav {
  const [stack, setStack] = useState<MobileScreen[]>([initial]);
  const [driverId, setDriverId] = useState('d1');
  const [scenario, setScenario] = useState<ScanScenario>('valid');
  const [reportContext, setReportContext] = useState<'valid' | 'invalid' | 'unauthorized'>('invalid');
  const [lastCaseId, setLastCaseId] = useState('IRR-2026-0372');
  const [toast, setToast] = useState<string | null>(null);
  const timer = useRef<number | undefined>(undefined);

  const go = useCallback((s: MobileScreen) => setStack((st) => [...st, s]), []);
  const back = useCallback(() => setStack((st) => (st.length > 1 ? st.slice(0, -1) : st)), []);
  const reset = useCallback((s: MobileScreen) => setStack(s === 'home' || s === 'splash' || s === 'login' ? [s] : ['home', s]), []);

  const showToast = useCallback((msg: string) => {
    setToast(msg);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setToast(null), 2400);
  }, []);

  return {
    screen: stack[stack.length - 1],
    go,
    back,
    reset,
    driverId,
    setDriverId,
    scenario,
    setScenario,
    reportContext,
    setReportContext,
    lastCaseId,
    setLastCaseId,
    toast,
    showToast
  };
}
